import { exists } from '../runtime.js';
import './ApiActivityType.js';
import './ApiAdditionalInfoType.js';
import './ApiAirportType.js';
import './ApiBaggageType.js';
import './ApiBaggageUnitType.js';
import { ApiBaseDataFromJSON, ApiBaseDataToJSON } from './ApiBaseData.js';
import './ApiBaseDataSource.js';
import './ApiBookingAction.js';
import './ApiBookingState.js';
import './ApiCabinClass.js';
import './ApiCamperFeatureType.js';
import { ApiCarFeaturesFromJSON, ApiCarFeaturesToJSON } from './ApiCarFeatures.js';
import { ApiCarRateFromJSON, ApiCarRateToJSON } from './ApiCarRate.js';
import './ApiClientType.js';
import './ApiComponentPriceType.js';
import './ApiComponentType.js';
import './ApiConfigurationDataType.js';
import './ApiDebitType.js';
import './ApiDirection.js';
import './ApiDistanceUnit.js';
import './ApiDocumentSubType.js';
import './ApiDocumentType.js';
import './ApiDurationType.js';
import './ApiFilterCategory.js';
import './ApiFilterType.js';
import './ApiFuelType.js';
import './ApiGender.js';
import { ApiImageContainerFromJSON, ApiImageContainerToJSON } from './ApiImageContainer.js';
import './ApiImageType.js';
import './ApiInventory.js';
import { ApiItemFromJSONTyped, ApiItemToJSON } from './ApiItem.js';
import './ApiItemType.js';
import './ApiNoteOriginType.js';
import './ApiNoteType.js';
import './ApiPackagePriceComponentType.js';
import './ApiPaymentDataType.js';
import './ApiPaymentOption.js';
import './ApiPaymentState.js';
import './ApiPriceModifierType.js';
import './ApiPriceType.js';
import './ApiRecommendationServiceType.js';
import './ApiRelatedServiceRelationType.js';
import { ApiRentalCarStationFromJSON, ApiRentalCarStationToJSON } from './ApiRentalCarStation.js';
import './ApiRole.js';
import './ApiRowCharacteristics.js';
import './ApiSeatCharacteristics.js';
import './ApiServiceSelectionType.js';
import './ApiSortDirection.js';
import './ApiSortOption.js';
import './ApiSpecialRequestGroup.js';
import './ApiStaticContentType.js';
import './ApiTaxDisplay.js';
import './ApiTransmissionType.js';
import { ApiTransportFeaturesFromJSON, ApiTransportFeaturesToJSON } from './ApiTransportFeatures.js';
import './ApiTravelStatusEnum.js';
import './ApiTravelerType.js';
import './ApiVoucherDeliveryType.js';
import './ApiWalletType.js';

/* tslint:disable */
function ApiRentalCarFromJSON(json) {
    return ApiRentalCarFromJSONTyped(json, false);
}
function ApiRentalCarFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...ApiItemFromJSONTyped(json, ignoreDiscriminator),
        'code': !exists(json, 'code') ? undefined : json['code'],
        'cmsCode': !exists(json, 'cmsCode') ? undefined : json['cmsCode'],
        'shortDescription': !exists(json, 'shortDescription') ? undefined : json['shortDescription'],
        'description': json['description'],
        'pickupDate': !exists(json, 'pickupDate') ? undefined : (json['pickupDate']),
        'pickupTime': !exists(json, 'pickupTime') ? undefined : json['pickupTime'],
        'pickupStation': !exists(json, 'pickupStation') ? undefined : ApiRentalCarStationFromJSON(json['pickupStation']),
        'dropoffDate': !exists(json, 'dropoffDate') ? undefined : (json['dropoffDate']),
        'dropoffTime': !exists(json, 'dropoffTime') ? undefined : json['dropoffTime'],
        'dropoffStation': !exists(json, 'dropoffStation') ? undefined : ApiRentalCarStationFromJSON(json['dropoffStation']),
        'carType': !exists(json, 'carType') ? undefined : json['carType'],
        'carTypeDescription': !exists(json, 'carTypeDescription') ? undefined : json['carTypeDescription'],
        'externalImgUrl': !exists(json, 'externalImgUrl') ? undefined : ApiImageContainerFromJSON(json['externalImgUrl']),
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'carFeatures': !exists(json, 'carFeatures') ? undefined : ApiCarFeaturesFromJSON(json['carFeatures']),
        'transportFeatures': !exists(json, 'transportFeatures') ? undefined : ApiTransportFeaturesFromJSON(json['transportFeatures']),
        'rates': !exists(json, 'rates') ? undefined : (json['rates'].map(ApiCarRateFromJSON)),
        'supplier': !exists(json, 'supplier') ? undefined : ApiBaseDataFromJSON(json['supplier']),
        'supplierImage': !exists(json, 'supplierImage') ? undefined : ApiImageContainerFromJSON(json['supplierImage']),
    };
}
function ApiRentalCarToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...ApiItemToJSON(value),
        'code': value.code,
        'cmsCode': value.cmsCode,
        'shortDescription': value.shortDescription,
        'description': value.description,
        'pickupDate': value.pickupDate === undefined ? undefined : (value.pickupDate),
        'pickupTime': value.pickupTime,
        'pickupStation': ApiRentalCarStationToJSON(value.pickupStation),
        'dropoffDate': value.dropoffDate === undefined ? undefined : (value.dropoffDate),
        'dropoffTime': value.dropoffTime,
        'dropoffStation': ApiRentalCarStationToJSON(value.dropoffStation),
        'carType': value.carType,
        'carTypeDescription': value.carTypeDescription,
        'externalImgUrl': ApiImageContainerToJSON(value.externalImgUrl),
        'notes': value.notes,
        'carFeatures': ApiCarFeaturesToJSON(value.carFeatures),
        'transportFeatures': ApiTransportFeaturesToJSON(value.transportFeatures),
        'rates': value.rates === undefined ? undefined : (value.rates.map(ApiCarRateToJSON)),
        'supplier': ApiBaseDataToJSON(value.supplier),
        'supplierImage': ApiImageContainerToJSON(value.supplierImage),
    };
}

export { ApiRentalCarFromJSON, ApiRentalCarFromJSONTyped, ApiRentalCarToJSON };
//# sourceMappingURL=ApiRentalCar.js.map
